import { useEffect, useRef, Dispatch } from 'react';
import dayjs from 'dayjs';

import useTranslation from 'customHooks/translate';

interface IProps {
  date: Date;
  countDown: number;
  setIsTimerRunning: Dispatch<React.SetStateAction<boolean>>;
  setCountDown: Dispatch<React.SetStateAction<number>>;
}

const Countdown = ({
  date,
  countDown,
  setCountDown,
  setIsTimerRunning,
}: IProps) => {
  const timerId = useRef<NodeJS.Timer>();
  const translation = useTranslation();

  useEffect(() => {
    if (dayjs().isAfter(date)) {
      setCountDown(0);
    } else {
      const secondsLeft = dayjs(date).diff(dayjs(), 'second');

      setCountDown(secondsLeft);
      setIsTimerRunning(true);
    }
  }, [date, setCountDown, setIsTimerRunning]);

  useEffect(() => {
    if (countDown > 0) {
      timerId.current = setInterval(() => {
        setCountDown((c) => {
          return c - 1;
        });
      }, 1000);
    } else {
      clearInterval(timerId.current);
      setIsTimerRunning(false);
    }

    return () => {
      clearInterval(timerId.current);
    };
  }, [countDown, setCountDown, setIsTimerRunning]);

  const seconds = String(countDown % 60).padStart(2, '0');
  const minutes = String(Math.floor(countDown / 60)).padStart(2, '0');

  return (
    <div className="space-y-2 text-charleston-green">
      <span className="block text-[30px] font-bold">
        {minutes}:{seconds}
      </span>
      <span className="block text-sm">{translation.checkEmail.TimeText}</span>
    </div>
  );
};

export default Countdown;
